export const API_BASE_URL = "https://www.rwittmer.com/api";
//export const API_BASE_URL = "http://localhost:3366/api";
export const PRIVACY_POLITICS_URL = "https://rolfwittmer-my.sharepoint.com/:b:/g/personal/edison_tiptoptravel_ec/Ee84Nxw4Y95NheVsaAbZDKsBIPWxVLfrQ3Gj_ldUdBu9Ig?e=oXfKo2git ";
export const SITE_KEY  = "6LdwozIrAAAAAPG-aHjQ7cuY5zmCahmpavoOhp5K";